(() => {
  const API_URL = "https://api.frankfurter.dev/v1/latest?from=USD&to=GBP"; // free, no key
  const CACHE_KEY = "fx_usd_gbp_rate_v1";
  const CACHE_TTL_MS = 12 * 60 * 60 * 1000;

  const gbpFmt = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  // If you truly want GBP for everyone, leave true.
  // If you only want UK-ish visitors, change to "return isUK();"
  function shouldConvert() { return true; }

  function isUK() {
    const lang = (navigator.language || "").toLowerCase();
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    return lang === "en-gb" || tz === "Europe/London";
  }

  function parseUsd(text) {
    if (!text) return null;
    const cleaned = text
      .replace(/USD/gi, "")
      .replace(/\$/g, "")
      .replace(/[^\d.,-]/g, "")
      .trim();

    if (!cleaned) return null;

    const hasComma = cleaned.includes(",");
    const hasDot = cleaned.includes(".");
    let normalized = cleaned;

    if (hasComma && hasDot) normalized = cleaned.replace(/,/g, ""); // 1,234.56
    else if (hasComma && !hasDot) normalized = cleaned.replace(",", "."); // 123,45

    const n = Number(normalized);
    return Number.isFinite(n) ? n : null;
  }

  function formatGbpRoundedUpTo10(amountGbp) {
    // round UP to nearest 10
    const rounded = Math.ceil(amountGbp / 10) * 10;

    // return as plain digits, no symbol, no commas, no decimals
    // return String(rounded);
    return "£ " + String(rounded) + " GBP";
  }


  async function getRate() {
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
      if (cached?.rate && cached?.ts && (Date.now() - cached.ts) < CACHE_TTL_MS) return cached.rate;
    } catch (_) {}

    const res = await fetch(API_URL, { cache: "no-store" });
    if (!res.ok) throw new Error("FX fetch failed");
    const data = await res.json();
    const rate = data?.rates?.GBP;
    if (!rate) throw new Error("FX rate missing");

    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ rate, ts: Date.now() }));
    } catch (_) {}

    return rate;
  }

  const MARK = "data-fx-gbp";

  // Sense/Dawn commonly uses these price wrappers/classes:
  // - .price and descendants (.price__regular, .price__sale)
  // - .price-item (often contains the "money" text)
  // - .money is also common
  const SELECTORS = [
    ".price .money",
    ".price-item",
    ".price__regular .price-item",
    ".price__sale .price-item",
    ".product__info-container .price-item",
    ".card-information .price-item",
    ".price"
  ].join(",");

  function convertIn(root, rate) {
    const nodes = root.querySelectorAll(SELECTORS);

    nodes.forEach((el) => {
      if (el.nodeType !== 1) return;
      if (el.hasAttribute(MARK)) return;

      const txt = (el.textContent || "").trim();

      // Guard: only convert if it clearly looks like USD
      // (If your store shows plain numbers with no "$" or "USD", tell me and I’ll adjust.)
      if (!(/\$/.test(txt) || /\bUSD\b/i.test(txt))) return;

      const usd = parseUsd(txt);
      if (usd === null) return;

      el.textContent = formatGbpRoundedUpTo10(usd * rate);
      el.setAttribute(MARK, "1");
    });
  }

  async function run() {
    if (!shouldConvert()) return;

    let rate;
    try { rate = await getRate(); }
    catch (_) { return; } // fail silently; keep USD

    convertIn(document, rate);

    // Keep it working when Sense updates prices dynamically (variants, cart drawer, etc.)
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n?.querySelectorAll) convertIn(n, rate);
        }
        if (m.type === "characterData" && m.target?.parentElement) {
          convertIn(m.target.parentElement, rate);
        }
      }
    });

    mo.observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
